import { type CSSProperties } from 'react';
import { css } from 'styled-components';
import { COLOR } from './styles';

interface ScrollbarsTypes {
  width: CSSProperties['width'];
  height: CSSProperties['height'];
  border: CSSProperties['border'];
  foregroundColor: CSSProperties['color'];
  backgroundColor: CSSProperties['color'];
}

interface ButtonColorsTypes {
  badge?: CSSProperties['color'];
  bg?: CSSProperties['color'];
  fg?: CSSProperties['color'];
  hoverBg?: CSSProperties['color'];
  hoverFg?: CSSProperties['color'];
  border?: CSSProperties['border'];
  hoverBorder?: CSSProperties['color'];
}

export const Scrollbars = ({
  width,
  height,
  border,
  foregroundColor,
  backgroundColor,
}: ScrollbarsTypes) => css`
  --scrollbar-color: ${foregroundColor} ${backgroundColor};
  --scrollbar-width: thin;

  // For Google Chrome
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: ${width};
    height: ${height};
    border-radius: 0;
  }

  &::-webkit-scrollbar-thumb {
    background: ${foregroundColor};
    border-radius: 0px;
    border: ${border} solid ${backgroundColor};
  }

  &::-webkit-scrollbar-track {
    background: ${backgroundColor};
  }

  // For Internet Explorer
  body {
    scrollbar-face-color: ${foregroundColor};
    scrollbar-track-color: ${backgroundColor};
  }
`;

export const ButtonColors = ({
  // eslint-disable-next-line
  // @ts-ignore
  badge = null,
  bg = COLOR['dark-gray-lighter'],
  fg = COLOR['white'],
  hoverBg = COLOR['primary-dark'],
  hoverFg = COLOR['white'],
  // eslint-disable-next-line
  // @ts-ignore
  border = null,
  // eslint-disable-next-line
  // @ts-ignore
  hoverBorder = null,
}: ButtonColorsTypes) => css`
  background: ${bg};
  color: ${fg};

  border-color: ${border ? border : ''};

  .icon,
  svg {
    fill: ${fg};
  }

  .badge {
    background: ${fg};
    color: ${badge ? badge : bg};
  }

  &:focus,
  &:hover {
    background: ${hoverBg};
    color: ${hoverFg};
    outline: none;
    border-color: ${hoverBorder ? hoverBorder : ''};

    .icon,
    svg {
      fill: ${hoverFg};
    }

    .badge {
      background: ${hoverFg};
      color: ${hoverBg};
    }
  }
`;

export const Transition = (args: string) => css`
  -webkit-transition: ${args};
  transition: ${args};
`;

export const Transform = (args: string) => css`
  -webkit-transform: ${args};
  -ms-transform: ${args};

  // IE9
  transform: ${args};
`;

// Grab Cursor
export const cusrsorGrab = () => css`
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
`;
export const cusrsorGrabbing = () => css`
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
`;
